import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "TRANSLATIONS";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "translations_list",
  urlBuilder: ({project_id, string_id}) => `translations/?project_id=${encodeURIComponent(project_id)}&string_id=${encodeURIComponent(string_id)}`
});

actionMeta.defineRequest({
    name: "translations_upload_default_messages",
    urlBuilder: ({project_id, string_id}) => `translations/?project_id=${encodeURIComponent(project_id)}`
});

actionMeta.defineRequest({
    name: "translations_upload_locale_messages",
    urlBuilder: ({project_id, string_id}) => `translations/?project_id=${encodeURIComponent(project_id)}&string_id=${encodeURIComponent(string_id)}`
});

actionMeta.defineRequest({
    name: "translations_update",
    urlBuilder: ({project_id, string_id}) => `translations/?project_id=${encodeURIComponent(project_id)}&string_id=${encodeURIComponent(string_id)}`
});

actionMeta.defineRequest({
    name: "translations_download_package",
    urlBuilder: ({project_id, format}) => `translations/download?project_id=${encodeURIComponent(project_id)}&format=${encodeURIComponent(format)}`
});




// WEBPACK FOOTER //
// ./src/storeState/translations/meta.js